enum FeatureToggle {
    EVALUATION_CHANGE_TOGGLE = "qm.release.evaluation.evaluatorchange",
    DISPUTES_TOGGLE = "qm.release.evaluation.disputes",
    SIDEPANEL_WIDTH_TOGGLE = "qm.ui.wem374",
    EVALUATION_ASSIGNEE_FEATURE_TOGGLE_NAME = "qm.release.evaluation.assignee",
    ASSESSMENT_UI_ENHANCEMENTS_TOGGLE = "learning.release.design.improvements.596.ui",
    REPORTING_TOGGLE = "WEM-556_QM_RELEASE_EVALUATION_REPORTING_CUSTOMER",
    LEARNING_SCORM = "learning.scorm",
    ADMIN_UI_DECOMPOSITION = "qm.adminUIDecomp",
    SYSTEM_MARKED_NA_FEATURE_TOGGLE_NAME = "qm.release.markedNAHiddenFlag",
    REVISION_CREATED_DATE_TOGGLE = "qm.17026.revision.created.date",
    VOICE_SURVEY = "qm.release.survey.voiceIVRSurvey",
    AI_SCORING = "qm.wem-964.evaluation.ai.scoring",
    EVALUATION_OVERVIEW_DEPRECATION = "WEM-1242_Evaluation-Dashboard-Deprecation",
    MULTIPLE_SELECT = "WEM-1107_MULTIPLE-SELECT",
    NEW_RESOURCE_CENTER_URI = "PURE-6363_new_resource_center_URI",
    AUTOMATED_EVALUATION_COMPLETION = "QM-18908_Automated_Evaluation_Completion",
    AI_SCORING_QUESTION_LIMIT_20 = "WEM-1330_AI_SCORING_QUESTION_LIMIT_20",
    EVALUATION_FORM_DEFAULT_ANSWERING = "WEM-1359_EVALUATION_FORM_DEFAULT_ANSWERING",
    INTERNATIONALIZATION_DATE_TIME = "PURE-2946_InternationalizationOfDatesAndTimes",
}
export default FeatureToggle;
